import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import PageHeader from "@/components/PageHeader";
import SectionHeading from "@/components/SectionHeading";
import Reveal from "@/components/Reveal";
import { MISSION, VISION } from "@/data/content";

export default function About() {
  return (
    <>
      <PageHeader
        eyebrow="About The Non-Profit"
        title="Changing Lives Through Sports"
        description="Louisiana Ducks is a non-profit youth sports organization based in St. Charles Parish, serving families across the New Orleans metro area. Our inaugural season kicks off in 2027."
        testid="about-header"
      />

      <section className="py-14 sm:py-20 bg-[#0A0A0A]" data-testid="about-mission-section">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-14 items-start">
            <Reveal>
              <div className="bg-[#111111] border border-[#333333] border-l-4 border-l-[#FEE123] p-8 sm:p-10" data-testid="about-mission-card">
                <p className="text-sm font-bold uppercase tracking-[0.3em] text-[#FEE123]">Mission Statement</p>
                <p className="mt-5 text-lg text-gray-200 leading-relaxed font-medium">{MISSION}</p>
              </div>
            </Reveal>
            <Reveal delay={0.15}>
              <div className="bg-[#111111] border border-[#333333] border-l-4 border-l-[#0F4D22] p-8 sm:p-10" data-testid="about-vision-card">
                <p className="text-sm font-bold uppercase tracking-[0.3em] text-[#FEE123]">Vision Statement</p>
                <p className="mt-5 text-lg text-gray-200 leading-relaxed font-medium">{VISION}</p>
              </div>
            </Reveal>
          </div>
        </div>
      </section>

      <section className="py-14 sm:py-20 bg-[#06220F]" data-testid="about-programs-section">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-10">
            <SectionHeading
              eyebrow="What We Offer"
              title="Nine Programs. One Goal."
              description="From tutoring and mentorship to scholarships and college exposure, every Ducks program exists to help young people reach their full potential."
              testid="about-programs-heading"
            />
            <Link
              to="/programs"
              data-testid="about-programs-link"
              className="shrink-0 inline-flex items-center justify-center gap-2 bg-[#FEE123] text-black text-base font-extrabold uppercase tracking-widest px-8 py-4 rounded-sm transition-transform duration-200 hover:scale-105 hover:bg-[#FFEA61]"
            >
              Explore Programs <ArrowRight size={18} />
            </Link>
          </div>
        </div>
      </section>

      <section className="relative py-14 sm:py-20 overflow-hidden bg-[#111111]" data-testid="about-impact-section">
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <Reveal>
            <h2 className="font-display text-5xl sm:text-6xl uppercase leading-none text-white max-w-3xl">
              Education. Character. Community.
            </h2>
            <p className="mt-6 text-base sm:text-lg text-gray-200 leading-relaxed max-w-2xl" data-testid="about-impact-text">
              As the only national team in South Louisiana, the Ducks set the standard for athletic excellence and
              academic success — and every program is open to the families who need it most, with financial
              assistance and sponsorship opportunities for qualifying athletes.
            </p>
          </Reveal>
        </div>
      </section>
    </>
  );
}
